@switch (columnName) {
  @default {
    {{ element[columnName] ?? '---' }}
  }
  @case ('status') {
    <app-ui-pill [name]="PROJECT_STATUS_LABELS[element.status] | lowercase"></app-ui-pill>
  }
}
